export default __webpack_public_path__ + "static/media/Eldermind Hood.a4bcbe16.jpg";